// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const companyCode = 'TP24';
export const environment = {
  companyCode: companyCode,
  production: false,
  "isPaymentHit": true,
  isAllowedCancellation: true,
  website: "TravelPortal24.com",
  defaultGateway: "CCAvenue",
  logoName: "TravelPortal24",
  companyShortName: "TravelPortal24",
  companyFullName: "TravelPortal24",
  mobileNo: "(+91) 9971-27-0406",
  emailId: "info@TravelPortal24.com",
  "AppRedirectURLFlight": "https://travelportal24.com/flight-payment",
  "AppRedirectURLHotel": "https://travelportal24.com/hotel-payment",
  //"AppRedirectURLHotel": "http://localhost:4200/hotel-payment",
  "AppRedirectURLSightseeing": "https://travelportal24.com/sightseeing/sightseeing-payment",
  "AppRedirectURLHoliday": "https://travelportal24.com/holiday/holiday-payment",
  "AppRedirectURLTransfer": "https://travelportal24.com/transfer/transfer-payment",

  UtilityBaseURL: 'https://SriUtilityApi.travelportal24.com/',
  GenericBaseURL: 'https://SriGenericApi.travelportal24.com/',
  //GenericBaseURL: 'http://localhost:51524/',
  PaymentInitiateURL: 'https://payment.sourcemytrip.co/PaymentSrv.asmx/PaymentInitiate',
  PaymentURL: "https://payment.sourcemytrip.co/API/PaymentWaiting.aspx?PG=",
  HotelBaseURL: 'https://SriHotelApi.travelportal24.com/',
  //HotelBaseURL: 'http://localhost:62216/',
  FlightBaseURL: 'https://SriFlightApi.travelportal24.com/',
  //FlightBaseURL: 'http://localhost:53734/',
  PackageBaseURL: 'https://SriPackageApi.travelportal24.com/',
  SightseeingBaseURL: 'https://SriSeightseeingApi.travelportal24.com/',
  TransferBaseURL: 'https://SriTransferApi.travelportal24.com/',
  //Common Info
  facebookLink: "https://www.facebook.com/RamDasInfotech/",
  instagramLink: "https://www.instagram.com/ramdasinfotech/",
  twitterLink: "https://twitter.com/ramdasinfotech/",
  linkedinLink: "https://www.linkedin.com/company/Ramdasinfotech",
  address: "A-69 B, 4th Floor, Golden I,Tower A, Sec- Techzone 4, Greater Noida West, UP - 201009",
  about: "This is a demo website-Not for real time booking, travelportal24 is the go-to platform for your travel needs. Find the best online flight tickets booking and hotel booking deals, and save money every time you hit the road for business or leisure.",
  DomainUrl: "https://travelportal24.com/",
  WebsiteTitle: "travelportal24 Travel Booking Engine"
};


